/**
* Class to work as a DTO to hold the information of a event dispatched to segment.
*/
class SegmentIdentifyEvent {   
    constructor(userId = '', traits = {}) {
      this.userId = userId;
      this.traits = traits;
    }
  }
  
  export default SegmentIdentifyEvent;